import React, { useState, useRef, useEffect } from "react"
import { Card, Avatar, Button, Switch } from "antd"
import { Link } from "react-router-dom"
import AntdIcons from "../../allAntdIcons";
import { Card as CardType } from "./CardTypes"
import "./cards.css"
import type { IconBaseProps } from "@ant-design/icons/lib/components/Icon"
import { Card as AntdCard } from "antd"
import Meta from "antd/es/card/Meta"
import CloseCircleOutlined from "@ant-design/icons/lib/icons/CloseCircleOutlined";

interface CardItemProps {
  card: CardType
  isDisplayed: boolean
  onToggle: (id: string) => void
  onRemove?: (id: string) => void
  isShakeMode: boolean
  avatarColor: string
  onColorChange: (id: string, color: string) => void // Callback to update the color
}

function getAntdIconByName(name: string, props?: IconBaseProps): JSX.Element {

  let icon = AntdIcons[name as keyof typeof AntdIcons];
  if (!icon && AntdIcons.default) {
    icon = (AntdIcons.default as any)[name];
  }


  if (
    typeof icon === "function" ||
    (typeof icon === "object" && icon && ("displayName" in icon || "render" in icon))
  ) {
    const IconComponent = icon as React.FC<IconBaseProps>;
    return <IconComponent {...props} />;
  }

  const Fallback = AntdIcons.QuestionCircleOutlined || (AntdIcons.default && (AntdIcons.default as any).QuestionCircleOutlined);

  return Fallback ? <Fallback {...(props as React.ComponentProps<typeof Fallback>)} /> : null;
}

const CardItem: React.FC<CardItemProps> = ({
  card,
  isDisplayed,
  onToggle,
  onRemove,
  isShakeMode,
  avatarColor,
  onColorChange,
}) => {
  const [isClicked, setIsClicked] = useState(false)
  const [showColorOptions, setShowColorOptions] = useState(false)
  const [isGlowing, setIsGlowing] = useState(false)
  const [isCrossfading, setIsCrossfading] = useState(false)
  const [prevColor, setPrevColor] = useState<string | null>(null)
  const [isBlurring, setIsBlurring] = useState(false)
  const overlayRef = useRef<HTMLDivElement>(null)

  const handleClick = (event: React.MouseEvent) => {
    setIsClicked(true)
    setTimeout(() => setIsClicked(false), 500) // Reset after animation
    event.preventDefault()
    window.open(card.link, "_blank")
  }

  // const predefinedColors = [
  //   "linear-gradient( 135deg,  #c9c9c9 0%,  #b3b3b3 25%,  #e0e0e0 50%,  #aaaaaa 75%,  #d5d5d5 100%)",
  //   "linear-gradient(135deg, #fffbd5, #f9d976, #f6e27a)",
  //   "linear-gradient(135deg, #a18cd1, #fbc2eb, #e0c3fc)",
  //   "linear-gradient(135deg, #ff9a9e, #fad0c4, #fbc2eb)",
  //   "linear-gradient(135deg, #c2e9fb, #a1c4fd, #d4fcff)",
  // ]
  // const handleColorChange = (color: string) => {
  //   setIsBlurring(true)
  //   setShowColorOptions(false)
  //   setTimeout(() => {
  //     onColorChange(card.id, color)
  //     setIsBlurring(false)
  //   }, 400)
  // }
  return (
    <div
      style={{
        position: "relative",
        animation: isShakeMode
          ? "unshake 0.5s infinite" // Apply shake animation if isShakeMode is true
          : "none",
      }}
    >
      {/* Remove Button */}
      {isShakeMode &&
        onRemove && ( // Show the remove button only in shake mode
          <Button
            type="text"
            danger
            onClick={() => onRemove(card.id)}
            style={{
              position: "absolute",
              fontSize: "10px",

              top: 8,
              right: 1,
              zIndex: 1,
              background: "none",
            }}
          >
            <CloseCircleOutlined
              style={{ fontSize: "20px", color: "rgb(146, 37, 37)" }}
            />
          </Button>
        )}
      {/* Color Picker Button */}
      {/* {isShakeMode && (
        <Button
          type="text"
          onClick={() => setShowColorOptions(!showColorOptions)}
          style={{
            position: "absolute",
            fontSize: "10px",
            top: 9,
            left: 2,
            zIndex: 1,
            background: "none",
          }}
        >
          <SettingOutlined style={{ fontSize: "20px", color: "grey" }} />
        </Button>
      )}
      {showColorOptions && (
        <div
          ref={overlayRef}
          style={{
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 2,
            display: "flex",
            flexDirection: "column", // vertical layout
            gap: "8px",
            background: "#fff",
            padding: "8px",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          }}
        >
          {predefinedColors.map((color) => (
            <div
              key={color}
              onClick={() => {
                handleColorChange(color)
              }}
              style={{
                width: "20px",
                height: "20px",
                background: color,
                borderRadius: "50%",
                cursor: "pointer",
                border: "1px solid #ccc",
              }}
            ></div>
          ))}
        </div>
      )} */}
      {/* Clickable Card */}
      <Link
        to={card.link}
        style={{ textDecoration: "none" }}
        onClick={handleClick}
      >
        {/* <div
          className="glass-gradient"
          style={{
            padding: "4px",
            borderRadius: "30px", // Increased borderRadius for more rounded appearance
            background: isBlurring ? prevColor || avatarColor : avatarColor,
            display: "inline-block",
            transition:
              "background 0.4s cubic-bezier(0.4,0,0.2,1), filter 0.4s cubic-bezier(0.4,0,0.2,1)",
            filter: isBlurring ? "blur(6px) brightness(1.2)" : "none",
            position: "relative",
            overflow: "hidden",
          }}
        > */}
        {isCrossfading && prevColor && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              borderRadius: "30px",
              background: prevColor,
              opacity: 1,
              transition: "opacity 0.4s cubic-bezier(0.4,0,0.2,1)",
              pointerEvents: "none",
              zIndex: 2,
              animation: "crossfadeOut 0.4s forwards",
            }}
          />
        )}

        <AntdCard
          className="shadowdrop"
          style={{
            borderRadius: "30px",
            alignItems: "center",
            height: "150px",
            width: "150px",
          }}
          hoverable={false}
          cover={
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingTop: 12,
              }}
            >
              <Avatar
                icon={(() => {
                  return getAntdIconByName(card.icon, {});
                })()}
                size={86}
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  alignSelf: "center",
                  marginBottom: -20,
                  backgroundColor: "var(--bg-light, rgb(255, 255, 255))",
                  color: "var(--text-dark, rgb(109, 109, 109))",
                }}
              />
            </div>
          }
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "48px",
              height: "100%",
            }}
          >
            <Meta
              description={card.title}
              style={{
                marginBottom: "8px",
                marginTop: "-20spx",
                textAlign: "center",
                // justifyContent: "center",
                fontSize: "14px",
                // overflow: "hidden",
                whiteSpace: "normal",
              }}
            />
          </div>
        </AntdCard>
        {/* </div> */}
      </Link>
    </div>
  )
}

export default CardItem
